import { render } from "./P096.vue?vue&type=template&id=49f298dd&scoped=true"
import script from "./P096.vue?vue&type=script&lang=js"
export * from "./P096.vue?vue&type=script&lang=js"

import "./P096.vue?vue&type=style&index=0&id=49f298dd&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49f298dd"]])

export default __exports__